import { z } from 'zod';

export const MAX_NOTA_BAIXA_BYTES = 5 * 1024 * 1024;
export const chaveNotaBaixaSchema = z.string().trim().optional().nullable()
  .transform((value) => value?.replace(/\s/g, '') || null)
  .refine((value) => value === null || /^\d{44}$/.test(value), 'Informe uma chave de acesso com 44 dígitos.');

export function podeDarBaixaLaudo(
  perfil: { empresaId?: string | null; roles?: string[] | null; ativo?: boolean },
  laudo: { parceiroId: string; status: string; baixa?: boolean },
) {
  return perfil.ativo !== false && !!perfil.empresaId && perfil.empresaId === laudo.parceiroId
    && !!perfil.roles?.includes('parceiro_negocios') && laudo.status === 'finalizado' && !laudo.baixa;
}

export type NotaBaixaArquivo = { nome: string; mime: string; bytes: Uint8Array };

export function validarNotaBaixa(arquivo: NotaBaixaArquivo) {
  if (!arquivo.bytes.length || arquivo.bytes.length > MAX_NOTA_BAIXA_BYTES) throw new Error('A nota deve ter até 5 MB e não pode estar vazia.');
  const nome = arquivo.nome.replace(/[\x00-\x1f\x7f/\\]/g, '-').trim().slice(0, 120);
  const mime = arquivo.mime.toLowerCase().split(';')[0].trim();
  const bytes = arquivo.bytes;
  const starts = (signature: number[]) => signature.every((b, i) => bytes[i] === b);
  if (mime === 'application/pdf' && /\.pdf$/i.test(nome) && starts([37, 80, 68, 70, 45])) return { nome, mime, ext: 'pdf' };
  if (mime === 'image/jpeg' && /\.jpe?g$/i.test(nome) && starts([255, 216, 255])) return { nome, mime, ext: 'jpg' };
  if (mime === 'image/png' && /\.png$/i.test(nome) && starts([137, 80, 78, 71, 13, 10, 26, 10])) return { nome, mime, ext: 'png' };
  if (['application/xml', 'text/xml'].includes(mime) && /\.xml$/i.test(nome)) {
    const xml = new TextDecoder().decode(bytes);
    if (/<(?:nfeProc|NFe)(?:\s|\/?>)/.test(xml) && !/<!DOCTYPE|<!ENTITY/i.test(xml)) return { nome, mime: 'application/xml', ext: 'xml' };
  }
  throw new Error('Anexe uma nota válida em PDF, XML de NF-e, JPG ou PNG.');
}
